import { getSecureItem } from "../../../utilsFunctions";
import { ImageBaseUrl } from "../../../Environment";
import pdfMake from "../pdfmakeWrapper";

// Convert image URL to base64
function getBase64ImageFromUrl(url) {
  return fetch(url, { mode: "cors" })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.blob();
    })
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
}

const PdfReportCustomerSaving = ({
  sortedData,
  fourBlockData,
  savingStatus,
  paymentStatus,
  tenureType,
  companyData,
  selectedCustomer,
}) => {
  const getAddress = (address) =>
    [
      address?.AddressStreet,
      address?.AddressLandmark,
      address?.AddressCity,
      address?.AddressState,
      address?.AddressPincode,
    ]
      .filter(Boolean)
      .join(", ");

  const imageUrl =
    getSecureItem("loggedinUserCompany") === "1365"
      ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
      : `${ImageBaseUrl}${companyData?.profilePic}`;

  getBase64ImageFromUrl(imageUrl)
    .then((imageBase64) => buildAndDownloadPdf(imageBase64))
    .catch((err) => {
      console.warn("Image load failed, continuing without logo:", err);
      buildAndDownloadPdf(null);
    });

  function buildAndDownloadPdf(imageBase64) {
    const headerSection = [
      {
        table: {
          widths: ["*"],
          body: [
            [
              {
                columns: [
                  imageBase64
                    ? { image: imageBase64, width: 60, height: 70 }
                    : {
                        text: "LOGO",
                        width: 60,
                        height: 70,
                        alignment: "center",
                        color: "#aaa",
                      },
                  {
                    width: "*",
                    alignment: "center",
                    stack: [
                      { text: companyData.companyName, style: "companyName" },
                      {
                        text: `Address: ${getAddress(companyData.address)}`,
                        style: "infoText",
                      },
                      {
                        text: `GSTIN: ${companyData.GstIn || ""} | Website: ${companyData.companyWebsite || ""}`,
                        style: "infoText",
                      },
                      {
                        text: `Mobile No: ${companyData.phone} | Email ID: ${companyData.companyMail}`,
                        style: "infoText",
                      },
                    ],
                  },
                ],
                columnGap: 10,
              },
            ],
          ],
        },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1 },
        margin: [0, 0, 0, 10],
      },
    ];

    const filterSection = [
      { text: "Customer Wise Saving Report", style: "title" },
      { text: `Customer Name: ${selectedCustomer}`, style: "filter" },
      { text: `Saving Status: ${savingStatus}`, style: "filter" },
      { text: `Payment Status: ${paymentStatus}`, style: "filter" },
      {
        text: `Tenure: ${tenureType}`,
        style: "filter",
        margin: [0, 0, 0, 20],
      },
    ].map((item) => ({ ...item, alignment: "center" }));

    const fourBlockRow = {
      table: {
        widths: ["25%", "25%", "25%", "25%"],
        body: [
          fourBlockData.map((item) => ({
            stack: [
              { text: item.heading, style: "fourBlockHeading" },
              { text: item.value, style: "fourBlockValue" },
            ],
            alignment: "center",
            style: "fourBlock",
          })),
        ],
      },
      layout: { hLineWidth: () => 1, vLineWidth: () => 1 },
      margin: [0, 0, 0, 10],
    };

    // Generate individual saving + optional collections tables
    const savingSections = sortedData.map((data, index) => {
      const customerName = `${data?.customer?.firstName} ${data?.customer?.lastName}`;
      const custId = data?.customer?.cust_id
        ? ` (${data?.customer?.cust_id})`
        : "";

      const mainTable = {
        table: {
          headerRows: 1,
          widths: ["auto", "*", "*", "*", "*", "*", "*", "*"],
          body: [
            [
              "Sr. No.",
              "Saving ID",
              "Customer",
              "Target",
              "Deposited",
              "Penalty",
              "Balance",
              "Remaining Dues",
            ].map((header) => ({
              text: header,
              style: "tableHeader",
              alignment: "center",
            })),
            [
              index + 1,
              data.savingId,
              customerName + custId,
              data.totalAmount,
              data.totalCollected,
              data.totalPenalty,
              data?.outstandingBalance,
              data.remainingDues,
            ],
          ],
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex === 0 ? "#f0f0f0" : null),
        },
        margin: [0, 5, 0, 5],
        dontBreakRows: false,
      };

      const collectionTable =
        Array.isArray(data.savingsCollections) &&
        data.savingsCollections.length > 0
          ? [
              {
                text: `Saving ID: ${data.savingId} - Collection Details`,
                bold: true,
                fontSize: 11,
                margin: [0, 5, 0, 3],
                alignment: "left",
              },
              {
                table: {
                  headerRows: 1,
                  widths: ["*", "*", "*", "*", "*", "*", "*"],
                  body: [
                    [
                      { text: "Due Date", style: "tableHeader" },
                      { text: "Collected Date", style: "tableHeader" },
                      { text: "Opening", style: "tableHeader" },
                      { text: "Installment", style: "tableHeader" },
                      { text: "Collected", style: "tableHeader" },
                      { text: "Closing", style: "tableHeader" },
                      { text: "Penalty", style: "tableHeader" },
                    ],
                    ...data.savingsCollections.map((col) => [
                      col.dueDate
                        ? new Date(col.dueDate).toLocaleDateString()
                        : "",
                      col.collectedDate
                        ? new Date(col.collectedDate).toLocaleDateString()
                        : "",
                      col.openingBalance ?? "",
                      col.Installment ?? "",
                      col.collectionAmount ?? "",
                      col.closingBalance ?? "",
                      col.penaltyApplied ?? "",
                    ]),
                  ],
                },
                layout: {
                  fillColor: (rowIndex) => (rowIndex === 0 ? "#f5f5f5" : null),
                },
                margin: [0, 0, 0, 10],
              },
            ]
          : [];

      return [mainTable, ...collectionTable];
    });

    const docDefinition = {
      content: [
        ...headerSection,
        ...filterSection,
        fourBlockRow,
        ...savingSections.flat(), // include all per-saving sections
      ],
      styles: {
        title: {
          fontSize: 16,
          bold: true,
          marginBottom: 10,
        },
        filter: {
          fontSize: 10,
          marginBottom: 2,
        },
        companyName: {
          fontSize: 14,
          bold: true,
          marginBottom: 4,
          marginTop: 5,
        },
        infoText: {
          fontSize: 9,
          lineHeight: 1.3,
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
        },
        fourBlockHeading: {
          fontSize: 11,
          bold: true,
          margin: [0, 5, 0, 2],
        },
        fourBlockValue: {
          fontSize: 10,
          margin: [0, 2, 0, 5],
        },
        fourBlock: {
          margin: [0, 5, 0, 5],
        },
      },
      defaultStyle: {
        alignment: "center",
        fontSize: 9,
      },
      pageMargins: [10, 10, 10, 10],
    };

    pdfMake.createPdf(docDefinition).download("CustomerWiseSavingReport.pdf");
  }
};

export default PdfReportCustomerSaving;